module.exports = __webpack_public_path__ + "7bae53740e0aa04ed589e72da6b52daf.svg";